// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"b8073f12","167":"dbea5c08","620":"e0751875","820":"f373b854"}[chunkId] + ".chunk.css";
};